/* program groups are the landing pages describing: part-time, full-time, summer etc */

import React from "react";

import Layout from "../components/layout";
import PrimaryMenu from "../components/primaryMenu";
import heroStyles from "../components/css/hero.module.scss";
import SubPageNav from '../sections/subPageNav'
import Text from "../sections/text"
import TitledSection from "../sections/titledSection"
import Logogrid from "../sections/logogrid";
import OfferBox from "../sections/offerBox"
import "../components/css/global.scss";
import AboutLinksData from "../data/AboutLinksData.json";

/* sections */
export default function({pageContext}) {

  // THIS GETS THE MAIN page data
  let data = pageContext.content.json_data.data; //.content.json_data.data
  console.log(data)
  // THIS GETS THE flyoutmenu navigation
  let navigation = pageContext.flyoutnav;

  // THIS GETS THE SUB NAVIGATION
  const subnavName = data.navigation;

  /****** THIS ONE IS CUSTOMED PER PAGE  *****/
  // THIS GETS THE  SUBLINKS FROM THE PAGE JSON
  let partners = data.partners;

  function search(nameKey, myArray){
    for (var i=0; i < myArray.length; i++) {
        if (myArray[i].name === nameKey) {
            return myArray[i];
        }
    }
  }

  let subnav = search(subnavName, navigation).json_data.data.content.subLinks

return (
  <Layout bHideSignup="true">
      <div className={heroStyles.heroNoSlide} style={{backgroundImage: "url(http://api.vanarts.com/assets/"+data.content.masthead+")"}}>
        <PrimaryMenu navigation={navigation} />
      </div>

      <SubPageNav title={data.content.title} linksData={subnav} linkLabel={data.content.linklabel} type="subpage"/>
      
      <Text>
          <div dangerouslySetInnerHTML={{__html: data.content.maincontent}}></div>
      </Text>

      <TitledSection title={partners.header}> 
        <div dangerouslySetInnerHTML={{__html: data.partners.content}}></div>
        <Logogrid logos={partners.logos} />

      </TitledSection>

      <Text theme="dark" process="false">
            <div dangerouslySetInnerHTML={{__html: data.additionalcontent.content}}></div>
        </Text>

        { 
      data.callout && 
        <OfferBox 
        highlight={data.callout.title} 
        cta={data.callout.ctaText} 
        link={data.callout.ctaURL} 
        coverImage={data.callout.boxImage}>
          <div dangerouslySetInnerHTML={{__html: data.callout.content}}></div> 
        </OfferBox>
  
      }

    </Layout>
  );
}
